module.exports = __webpack_public_path__ + "img/9788946065901.87b0f08b.jpg";